<div [class]="containerClass" class="w-full">
  @if (label) {
    <label [for]="id" [class]="getLabelClasses()">{{ label }}</label>
  }

  <div class="w-full relative">
    @if (formControl) {
      <p-password
        [id]="id"
        [placeholder]="placeholder"
        [required]="required"
        [disabled]="disabled"
        [formControl]="$any(formControl)"
        (onInput)="onFormControlInput($event)"
        [inputStyleClass]="
          'w-full h-10 px-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-botmaaOrange pr-10'
        "
        [toggleMask]="true"
        [feedback]="false"
        (onBlur)="onTouched()"
        styleClass="w-full"
        [autofocus]="false"
      ></p-password>
    } @else {
      <p-password
        [id]="id"
        [placeholder]="placeholder"
        [required]="required"
        [disabled]="disabled"
        [ngModel]="value"
        (ngModelChange)="onChange($event)"
        (onInput)="onInput($event)"
        [inputStyleClass]="
          'w-full h-10 px-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-botmaaOrange pr-10'
        "
        [toggleMask]="true"
        [feedback]="false"
        (onBlur)="onTouched()"
        styleClass="w-full"
        [autofocus]="false"
      ></p-password>
    }
  </div>

  <span
    [class]="errorClass"
    role="alert"
    [style.display]="showError && errorMessage ? 'block' : 'none'"
    [style.min-height]="'1.25rem'"
    >{{ errorMessage || '&nbsp;' }}</span
  >
</div>
